import { useQuery } from "react-query";
import { TvCodeRes, UserRes } from "../types";
import { generateSignedRequestConfig, getBaseUrl, handleResponse } from "../utils";

const useGetTvCode = ({ dispatch, errorText, user }: { dispatch: any, errorText: string, user: UserRes }) => {
  const { apiKey, apiSecret, countryCode, id } = user;

  const config = generateSignedRequestConfig({
    apiKey,
    apiSecret,
    countryCode,
    id,
    method: 'GET',
    url: `${getBaseUrl()}/api/auth/transferSession`,
  });

  return useQuery<TvCodeRes>(
    [
      'fetchTvCode',
      {
        config
      }
    ],
    () => fetch(config.url, { ...config }).then(res => handleResponse(res)),
    {
      enabled: true,
      onError: (error: any) => {
        console.error('Error getting TV code: ', error);
        dispatch({
          type: 'ADD_MESSAGE',
          payload: {
            dismissable: true,
            id: new Date().getTime(),
            text: errorText,
            timeout: 7,
            type: 'error',
          },
        });
      },
      retry: 0,
      staleTime: 0
    }
  );
}

export default useGetTvCode